const Footer = () => {
    return (
        <>
            <div className="p-sm-0">
                <div className="d-flex justify-content-center align-content-center bg-primary2 text-white container-fluid">
                    <div className="d-flex flex-row">
                        <p className="text-center footer-text copyright-text">Copyright© {new Date().getFullYear()} CURE (Citizens United Reciprocal Exchange).<br /> All rights reserved.</p>
                        <p className="m-3 text-center footer-text mobile-footer">Customer Service<br />800-535-2873</p>
                        <p className="m-3 text-center footer-text mobile-footer">Roadside Assistance<br />866-522-1991</p>
                        <p className="m-3 text-center footer-text mobile-footer">Report Claim<br />800-229-9151</p>
                        <p className="m-3 text-center footer-text mobile-footer">214 Carnegie Center, Suite 301<br />Princeton, NJ 08540</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;